import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import "./EmailComponent.css"

const REQUEST_ACCESS = gql`
  mutation RequestAccess($state: String!, $email: String!) {
    requestAccess(state: $state, email: $email) {
      success
      message
    }
  }
`;

export default function EmailRequestComponent({ state }) {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [requestAccess, { data, loading }] = useMutation(REQUEST_ACCESS);

  const handleSubmit = async () => {
    if (!email) return;
    await requestAccess({ variables: { state, email } });
    setSubmitted(true);
  };

  return (
    <div className="email-request-wrapper">
     <div className="email-request-form">
       <div className="email-input-group">
        <input
          type="email"
          placeholder="e.g. patient@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="email-input"
        />
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="email-submit-button"
        >
          {loading ? "Sending..." : "Request Access"}
        </button>
      </div>
    </div>
  </div>

  );
}
